import appCredits from "../../views/appSettings/credits.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "credits";
  const params = ["page", "limit"];

  $stateProvider.state("credits", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCredits,
      },
    },
    reloadOnSearch: false,
    data: { title: "Credits" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/credits/credits.urls.js